import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useRealtyStore } from '../../../../stores/realty-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useEffect, useId } from 'react';
import {
  type RealtyFilterTemplateSetting,
  type UnderConstructionSearchCapability,
} from '../realty-filter-recipe';
import styles from '../realty-filter.module.css';
import { RealtyFilterCheckbox } from './utils/realty-filter-checkbox';

type RealtyFilterNewBuildingsOnlyProps = {
  templateSetting?: RealtyFilterTemplateSetting;
  searchCapability?: UnderConstructionSearchCapability;
};

export const RealtyFilterNewBuildingsOnly = ({
  templateSetting,
  searchCapability = 'unavailable',
}: RealtyFilterNewBuildingsOnlyProps) => {
  const { t } = useTranslations();
  const { filter, setFilter } = useRealtyStore();
  const instanceId = useId();
  const headingId = `${instanceId}-realty-filter-new-building-heading`;
  const isAvailable = searchCapability === 'indexed';

  useEffect(() => {
    if (!isAvailable && filter.is_new) {
      setFilter({ is_new: undefined });
    }
  }, [filter.is_new, isAvailable, setFilter]);

  const handleFilterUpdate = () => {
    if (!isAvailable) return;

    setFilter({
      is_new: !filter.is_new,
    });
  };

  if (templateSetting && !templateSetting.enabled) {
    return null;
  }

  return (
    <div className={styles.fieldGroup} style={{ order: templateSetting?.order }}>
      <section className={styles.section} aria-labelledby={headingId}>
        <h2 id={headingId} className={styles.heading}>
          {t('text1418')}
        </h2>
        <RealtyFilterCheckbox
          isSelected={() => isAvailable && (filter.is_new ?? false)}
          handleFilterUpdate={handleFilterUpdate}
          disabled={!isAvailable}
          filterKey="is_new"
          idPrefix={`${instanceId}-realty-filter-new-building`}
          copyClassName={styles.newBuildingCopy}
          item={{
            id: 1,
            name: t('text1417'),
          }}
        />
      </section>
      <Separator className={styles.separator} />
    </div>
  );
};
